import { BaseModel } from './BaseModel';

export type RustPermissionFramework = 'oxide' | 'carbon' | 'vanilla';
export type RustPermissionSyncStatus = 'disabled' | 'pending_import' | 'importing' | 'active' | 'error';
export type RustPermissionOpStatusValue = 'pending' | 'inflight' | 'applied' | 'noop' | 'failed' | 'superseded' | 'cancelled';
export type RustPermissionOpTypeValue =
    | 'group.create'
    | 'group.delete'
    | 'group.set_title'
    | 'group.set_rank'
    | 'group.set_parent'
    | 'group.grant'
    | 'group.revoke'
    | 'user.add_group'
    | 'user.remove_group'
    | 'user.grant'
    | 'user.revoke'
    | 'user.set_auth_level';

export class RustPermissionSettings extends BaseModel {
    public enabled: boolean = false;
    public status: RustPermissionSyncStatus = 'disabled';
    public framework: RustPermissionFramework | null = null;
    public moduleVersion: string | null = null;
    public socketOnline: boolean = false;
    public hashesMatch: boolean = false;
    public lastHandshakeAt: string | null = null;
    public lastDeltaAt: string | null = null;
    public lastImportAt: string | null = null;
    public lastError: string | null = null;
}

export class RustPermissionGroup extends BaseModel {
    public id: string = '';
    public name: string = '';
    public title: string | null = null;
    public rank: number = 0;
    public parent: string | null = null;
    public permissions: string[] = [];
    public membersCount: number = 0;
    public isDefault: boolean = false;
    public updatedAt: string | null = null;
}

export class RustPermissionUser extends BaseModel {
    public id: string = '';
    public steamId: string = '';
    public nickname: string | null = null;
    public permissions: string[] = [];
    public authLevel: number = 0;
    public groups: string[] | null = null;
    public updatedAt: string | null = null;
}

export class RustPermissionOp extends BaseModel {
    public id: string = '';
    public source: 'panel' | 'game' | 'import' = 'panel';
    public status: RustPermissionOpStatusValue = 'pending';
    public op: RustPermissionOpTypeValue = 'group.grant';
    public targetKey: string = '';
    public payload: Record<string, any> = {};
    public error: string | null = null;
    public actor: string | null = null;
    public appliedAt: string | null = null;
    public createdAt: string | null = null;
}
